import { LogoOpentofu, LogoTerraform } from "components/icons/generated";
import { Gear } from "components/icons/generated";
import { TERRAGRUNT_MANUALLY_PROVISIONED } from "constants/vendor";
import { TerragruntTool } from "types/generated";

export const getTerragruntToolDetails = (tool: TerragruntTool, toolVersion: string | undefined) => {
  let toolIcon = LogoTerraform;
  let toolText = toolVersion;

  if (tool === TerragruntTool.OpenTofu) {
    toolIcon = LogoOpentofu;
  } else if (tool === TerragruntTool.ManuallyProvisioned) {
    toolIcon = Gear;
    toolText = TERRAGRUNT_MANUALLY_PROVISIONED;
  }

  return {
    icon: toolIcon,
    text: toolText,
  };
};
